import type { FaireProductEntity } from "../../entity_types/product";

export const p_a8usq79s3n: FaireProductEntity = {
  token: "p_a8usq79s3n",
  type: "product",
  name: "POG Salt Water Taffy",
  brandName: "Lake Erie Candy Company",
  imageUrl:
    "https://cdn.faire.com/fastly/cb6df77f3c14a884913d2cf56bb1851951ea428c7a2cc1078640fdafad5663d7.jpeg",
  priceDollars: 3.23,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/9c16f7198487a2938b716fcf6bec27100ec135ea5dc47376ed60f74643a8eea2.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
